<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-file-pdf"></i>  {{title | translate}}</h4>
    <div class="text-right">
      <button class="btn btn-outline-success mt-2 mb-1"
              type="button" (click)="addRow()">+ {{ "BUTTON.ATTACHED" | translate }}
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-alert-add-document></app-alert-add-document>
    <form [formGroup]="documentForm">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="workflowInput">{{ "LABEL.WORKFLOW" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-code-branch"></i>
              </div>
            </div>
            <select id="workflowInput"
                    class="form-control"
                    [(ngModel)]="workflowSelected"
                    formControlName="workflow">
              <option *ngFor="let workflow of workflows"
                      [ngValue]="workflow">{{workflow.description | translate}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="subjectInput">{{ "LABEL.SUBJECT" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-keyboard" aria-hidden="true"></i></div>
          </div>
          <input type="text"
                 id="subjectInput"
                 class="form-control"
                 [(ngModel)]="document.subject"
                 formControlName="subject"
                 [class.is-invalid]="isInvalidControl('subject')">
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-8">
          <label>{{ "LABEL.DOCUMENT" | translate }}</label>
        </div>
        <div class="col-md-4">
          <label><small>{{ "LABEL.LOADING-PROGRESS-DOCUMENT" | translate }}</small></label>
        </div>
      </div>
      <div formArrayName="arrayDocument">
        <div class="form-row" *ngFor="let group of arrayDocument.controls; let index= index" [formGroupName]="index">
          <div class="col-md-8">
            <div class="padding-select-file">
              <div class="custom-file content-file">
                <input type="file" class="custom-file-input w-100 content-file" accept="application/pdf"
                       id="customFile{{index}}" (change)="changeStatus($event, index)">
                <label class="custom-file-label"
                       for="customFile{{index}}">
                  {{group.get('filename').value ? group.get('filename').value : "MESSAGE.SELECT" | translate}}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="progress form-group mt-2">
              <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                   [style.width.%]="progressUpdate">
              </div>
            </div>
          </div>
          <div class="col-md-1">
            <i class="fa fa-times mt-2"
               *ngIf="arrayDocument.controls.length > 1"
               (click)="deleteRow(index)"></i>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-outline-success mt-2 mb-1"
                type="button" (click)="addRowParticipant()">+ {{ "BUTTON.SIGNER" | translate }}
        </button>
      </div>
      <div class="mt-2 table-responsive">
        <table class="table-bordered table-sm">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" class="text-center custom-col-width">{{ "TABLE.HEADER.DOCUMENT-NUMBER" | translate }}</th>
            <th scope="col" class="text-center">{{ "TABLE.HEADER.NAME" | translate }}</th>
            <th scope="col" class="text-center">{{ "TABLE.HEADER.TYPE-SIGNATURE" | translate }}</th>
            <th scope="col" class="text-center">TSA</th>
            <th scope="col" class="text-center">{{"TABLE.HEADER.RUBRIC-DRAGGING" | translate}}</th>
            <th scope="col" class="text-center">{{"TABLE.HEADER.INTEGRITY" | translate}}</th>
            <th scope="col" class="text-center"><i class="fa fa-user-plus"></i></th>
            <th scope="col" class="text-center"><i class="fa fa-trash"></i></th>
          </tr>
          </thead>
          <tbody formArrayName="arrayParticipant">
          <tr *ngFor="let group of arrayParticipant.controls; let index=index" [formGroupName]="index">
            <td scope="row" title="#">{{index + 1}}</td>
            <td title="{{ 'TABLE.HEADER.DOCUMENT-NUMBER' | translate }}">
              <input type="text"
                     class="form-control form-control-custom text-center"
                     formControlName="documentNumber"
                     readonly>
            </td>
            <td title="{{ 'TABLE.HEADER.NAME' | translate }}">
              <input type="text"
                     class="form-control form-control-custom text-center"
                     formControlName="fullname"
                     data-toggle="tooltip" data-placement="top" title="{{group.get('fullname').value}}"
                     readonly>
            </td>
            <td title="{{ 'TABLE.HEADER.TYPE-SIGNATURE' | translate }}">
              <select class="form-control custom-select-1 content-position"
                      formControlName="typeSignature"
                      (ngModelChange)="reload(group, 'typeSignature')">
                <option [value]='1'>{{ "LABEL.DIGITAL-S" | translate }}</option>
                <option [value]='0'>{{ "LABEL.GRAPHIC-S" | translate }}</option>
              </select>
            </td>
            <td title="TSA">
              <div class="custom-control custom-checkbox mr-sm-2 custom-top">
                <input type="checkbox"
                       class="custom-control-input"
                       id="tsaCheckbox{{index}}"
                       name="tsa{{index}}"
                       formControlName="tsa"
                       [attr.disabled]="!isDigitalSignature(index) ? '' : null">
                <label class="custom-control-label" for="tsaCheckbox{{index}}"></label>
              </div>
            </td>
            <td title="{{ 'TABLE.HEADER.RUBRIC-DRAGGING' | translate }}">
              <div class="custom-control custom-checkbox mr-sm-2 custom-top">
                <input type="checkbox"
                       class="custom-control-input"
                       id="dragRubric{{index}}"
                       name="dragRubric{{index}}"
                       formControlName="dragRubric">
                <label class="custom-control-label" for="dragRubric{{index}}"></label>
              </div>
            </td>
            <td title="{{ 'TABLE.HEADER.INTEGRITY' | translate }}">
              <div class="custom-control custom-checkbox mr-sm-2 custom-top">
                <input type="checkbox"
                       class="custom-control-input"
                       id="integrity{{index}}"
                       name="integrity{{index}}"
                       formControlName="integrity"
                       [attr.disabled]="isDigitalSignature(index) ? '' : null">
                <label class="custom-control-label" for="integrity{{index}}"></label>
              </div>
            </td>
            <td title="Editar">
              <i class="fa fa-user-plus"
                 *ngIf="isEditable(index)"
                 (click)="loadRequiredDataAndOpenModal(index)"
                 [routerLink]="">
              </i>
            </td>
            <td title="{{arrayParticipant.controls.length > 1 ? 'Eliminar':''}}">
              <i class="fa fa-times"
                 *ngIf="arrayParticipant.controls.length > 1"
                 (click)="deleteParticipantRow(index)"></i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="form-group" *ngIf="isDocModification">
        <label for="reasonModificationInput">{{ "LABEL.REASON-MODIFICATION" | translate }}</label>
        <textarea id="reasonModificationInput"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'MESSAGE.ENTER-REASON-MODIFICATION' | translate }}"
                  formControlName="reasonModification"
                  [(ngModel)]="document.reasonModification" [rows]="2">
                  </textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-outline-success "
            [disabled]="documentForm.invalid || !areValidPeople || uploading"
            (click)="save()">
      <i class="fa fa-bookmark"></i>  {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i>  {{ "BUTTON.CLOSE" | translate }}
    </button>
  </div>
</div>

<app-loading *ngIf="loading"></app-loading>
